import styles from './FeatureFlagBanner.module.css'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

/**
 * Shows only the dev-only localStorage layer (e.g. `?flags=…` previews). The
 * server-resolved flags from `/v1/me` are silent — they are the authoritative
 * source and there's nothing to clear.
 */
export function FeatureFlagBanner() {
  const { devOverrides, clearFlags } = useFeatureFlags()

  if (devOverrides.length === 0) return null

  return (
    <div className={styles.pill}>
      <span className={styles.label}>Dev flag overrides:</span>
      <span className={styles.flags}>{devOverrides.join(', ')}</span>
      <button className={styles.clearButton} onClick={clearFlags} aria-label="Clear feature flags">
        ×
      </button>
    </div>
  )
}
